const daysToSeconds = days => days * 24 * 60 * 60;
const IN_SECONDS = {
  YEAR: daysToSeconds(365),
  MONTH: daysToSeconds(30),
  DAY: daysToSeconds(1),
  HOUR: 3600,
  MINUTES: 60
};

/**
  If same day, only hours lapsed, then display minutes/hours lapsed (ie. 8m, 2h)
  If same year, days or months lapsed, then display Mon and DD (i.e. Jan 10, Feb 13)
  If previous year, then display MM/DD/YY (i.e. 10/22/22)
 */

export default function timeSince(date) {
  const seconds = Math.floor((new Date() - date) / 1000);
  let interval = seconds / IN_SECONDS.YEAR;
  if (interval > 1) {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(date);
  }
  interval = seconds / IN_SECONDS.DAY;
  if (interval > 1) {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric"
    }).format(date);
  }
  interval = seconds / IN_SECONDS.HOUR;
  if (interval > 1) {
    return Math.floor(interval) + " h";
  }
  interval = seconds / IN_SECONDS.MINUTES;
  if (interval > 1) {
    return Math.floor(interval) + " m";
  }
  return Math.floor(seconds) + " s";
}
//# sourceMappingURL=timeSince.js.map